import { UUID } from '../uuid';
import { PagedData } from '../paged-data';
import { PathDao } from './path.dao';

/**
 * The search result the backend wraps around a found resource. `T` is whatever the service puts
 * into `resource`: the entity itself (users, devices) or the tree-utils `SearchResource` wrapper
 * (tenants, organisations, teams). Every field is optional because the backend may omit any of them.
 */
export interface SearchResultDao<T> {
  resourceId?: UUID;
  resourceType?: string;
  resource?: T;
  paths?: PathDao[];
}

/**
 * Drops the results the backend sent without a `resource` — there is nothing to show for them — and
 * warns about each one, because a missing resource means the backend broke its contract.
 * `totalElements` is left alone: it counts the whole result set, not this page.
 */
export function withoutResultsMissingResource<T>(page: PagedData<SearchResultDao<T>>): PagedData<SearchResultDao<T> & { resource: T }> {
  if (!page?.content) {
    return page as PagedData<SearchResultDao<T> & { resource: T }>;
  }
  const content = page.content.filter((result): result is SearchResultDao<T> & { resource: T } => result.resource != null);
  if (content.length === page.content.length) {
    return { ...page, content };
  }
  page.content
    .filter((result) => result.resource == null)
    .forEach((result) => console.warn(`Dropped search result without resource: ${result.resourceType} ${result.resourceId}`));
  return { ...page, content };
}
